//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const BankRecKanbanConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/bankRec/kanban',
      component: FuseLoadable({
          loader: () => import('./Board')
      })
  }
  ]
  //end routes
};
